import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/organization/member/invite";
const VERSION = 0;

export default async function resendInvite(email: string): Promise<void> {
    const options: httpNetworking.PUTRequestConfig = {
        timeout: 50000
    };
    const params = {
        email
    };

    const response = (await httpNetworking.simplePUTRequest(URL, params, options, VERSION)).data;
    return response;
}
